// extracted by mini-css-extract-plugin
export var component = "ReadingOptions-module--component--45eb6";
export var fadePop = "ReadingOptions-module--fade-pop--7fe30";
export var growHeightIn = "ReadingOptions-module--grow-height-in--d9f98";